module.exports = "/images/metiers.svg?c9da8f95c6821a82d47d9e5fd39123a8";